export default __webpack_public_path__ + "static/media/sipher-planet.9e188b43.png";